export const CAN_SUBMIT = 'CAN_SUBMIT';